const PAST_DUE_GRACE_MS = 7 * 24 * 60 * 60 * 1000;
const TRIAL_GRACE_MS = 24 * 60 * 60 * 1000;

function atMs(now) {
  return now instanceof Date ? now.getTime() : new Date(now).getTime();
}

/**
 * Dashboard access is the subscription status only.
 * A Stripe customer id does not keep a canceled account in.
 * past_due is allowed for 7 days after subscription_current_period_end.
 * A past_due row with no period end is allowed so a missed webhook does not
 * lock the account before the end date is stored.
 * trialing is denied once trial_ends_at is more than one day in the past.
 */
function subscriptionAllowsAccess(profile, now = new Date()) {
  if (!profile || profile.role === 'super_admin') {
    return profile ? profile.role === 'super_admin' : false;
  }
  const status = profile.subscription_status;
  const at = atMs(now);
  if (status === 'active') return true;
  if (status === 'trialing') {
    if (!profile.trial_ends_at) return true;
    const trialMs = new Date(profile.trial_ends_at).getTime();
    if (Number.isNaN(trialMs)) return true;
    return at <= trialMs + TRIAL_GRACE_MS;
  }
  if (status !== 'past_due') return false;
  if (!profile.subscription_current_period_end) {
    console.warn('past_due profile has no subscription_current_period_end; allowing access until a period end is stored');
    return true;
  }
  const endMs = new Date(profile.subscription_current_period_end).getTime();
  if (Number.isNaN(endMs)) return false;
  return at <= endMs + PAST_DUE_GRACE_MS;
}

function subscriptionFailure(profile) {
  if (!profile) return { status: 401, error: 'Unauthorized' };
  if (profile.role === 'super_admin' || subscriptionAllowsAccess(profile)) return null;
  return { status: 402, error: 'An active subscription is required' };
}

/** Homeowner and invite callers are not subscription-gated. */
function gateAgentCaller(agentOk, profile) {
  if (!agentOk) return null;
  return subscriptionFailure(profile);
}

module.exports = {
  PAST_DUE_GRACE_MS,
  TRIAL_GRACE_MS,
  subscriptionAllowsAccess,
  subscriptionFailure,
  gateAgentCaller,
};
